import React from 'react';
import { get, find, head } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { singleSelectField as SingleSelectFieldView } from 'ui/views/generic/singleSelectField';
import { Icon } from 'modules/icon-bank';
import { FORM_FIELDS } from 'constants/common';
import classNames from 'classnames';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { singleSelectWithStaticDesc as SingleSelectWithStaticDesc } from 'ui/views/generic/singleSelectWithStaticDesc';
 *
 * // render
 * <SingleSelectWithStaticDesc propName='propValue'/>
 */
export const singleSelectWithStaticDesc = ( props ) => {

    // if description to be shown always
    const showDescriptionAlways = get( props, 'config.showStatisDescAlways', false );

    // get description for config
    const description = showDescriptionAlways
                        ? getLabel( get( head( get( props, 'config.staticDescription', [] ) ), 'description', {} ) )
                        : getLabel( get( find( get( props, 'config.staticDescription', [] ), { value: props.value }, {} ), 'description', {} ) );
    
    const showDescription = showDescriptionAlways || '' !== props.value;

    // show info red icon in case of po box field
    const iconName = FORM_FIELDS.PO_BOX === props.name ? 'infoRed' : 'info';
    const className = classNames( 'ui-single-select-with-static-desc', props.className );

    const descriptionClassNames = classNames( 'ui-single-select-with-static-desc__description-wrapper__description', {
        [ `ui-single-select-with-static-desc__description-wrapper__description--${props.value}` ]: showDescription
    } );

    return (
        <div className={className}>
            <div className='ui-single-select-with-static-desc__field'>
                <SingleSelectFieldView
                    { ...props }
                />
            </div>

            <div className='ui-single-select-with-static-desc__description-wrapper'>
                {/* show description, if applicable */}
                {
                    showDescription ? (
                        <div className={ descriptionClassNames }>
                            <div className='ui-single-select-with-static-desc__description-wrapper__description__icon'>
                                <Icon name={ iconName } width='14' height='14' fill='#ffffff' />
                            </div>
                            <div className='ui-single-select-with-static-desc__description-wrapper__description__text'>
                                { description }
                            </div>
                        </div>
                    ) : null
                }
            </div>
        </div>
        
    );
};

// set display name
singleSelectWithStaticDesc.displayName = 'singleSelectWithStaticDesc';

// set default props
singleSelectWithStaticDesc.defaultProps = {};

// prop types
singleSelectWithStaticDesc.propTypes = {};
